module.exports = __webpack_public_path__ + "static/media/gcdef_117.2362fc62.ico";